/** Seasonal THALIA lore drops. Not live: shown as "coming" only (no schedule promised). */
export default function LoreDrops() {
  const drops = ['Season prologue: why THALIA keeps the clock running', 'Faction files: one short story per Variance Cell', 'Drone logs: what the THALIA Drones say when nobody is watching'];
  return (
    <div className="drones-faq" data-testid="lore-drops">
      <h3>📜 Seasonal THALIA lore <span className="pill coming">coming</span></h3>
      <p style={{ color: '#9fc3c9', fontSize: 14 }}>Short story drops each season. Not live yet.</p>
      <ul style={{ color: '#9fc3c9', fontSize: 14, lineHeight: 1.6, paddingLeft: 18, listStyle: 'disc' }}>{drops.map((d) => <li key={d}>{d}</li>)}</ul>
    </div>
  );
}
